import { ProcessLogo } from "@certa/blocks/thanos";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { classNames } from "@certa/catalyst/utils/common";
import { RelatedProcesses } from "@certa/icons/components/RelatedProcesses";
import { css } from "emotion";
import { useState } from "react";

const styles = {
  logoContainer: (borderRadius?: string) =>
    css({
      backgroundColor: "var(--colors-neutral-300)",
      color: "var(--colors-neutral-700)",
      borderRadius: borderRadius || "50%"
    })
};

type IconContainerProps = {
  icon: React.ReactNode;
  borderRadius?: string;
};

export const IconContainer = ({ icon, borderRadius }: IconContainerProps) => {
  return (
    <Stack
      align="center"
      justify="center"
      width="2rem"
      height="2rem"
      padding="8"
      dangerouslySetClassName={classNames(
        styles.logoContainer(borderRadius),
        "listing-item-icon"
      )}
    >
      {icon}
    </Stack>
  );
};

export const WorkflowLogo = ({
  logoUrl,
  name,
  borderRadius
}: {
  logoUrl?: string | null;
  name: string;
  style?: React.CSSProperties;
  borderRadius?: string;
}) => {
  const [hasError, setHasError] = useState(false);
  return (
    <>
      {logoUrl && !hasError ? (
        <ProcessLogo
          logoURL={logoUrl}
          name={name}
          height={32}
          width={32}
          onError={() => setHasError(true)}
        />
      ) : (
        <IconContainer
          icon={<RelatedProcesses size={16} />}
          borderRadius={borderRadius}
        />
      )}
    </>
  );
};
